/*
 * Copyright (c) 2000-2022 TeamDev. All rights reserved.
 * TeamDev PROPRIETARY and CONFIDENTIAL.
 * Use is subject to license terms.
 */

import {createPinia, PiniaVuePlugin} from 'pinia'
import useProductsStore from '@/stores/products/products';
import useCommercialLicensesStore from '@/stores/licenses/commercial';

/**
 * Setups and applies the Pinia store management plugin for the provided Vue app constructor.
 *
 * @param {Vue} vue the Vue app constructor for which to create a store
 */
export default function initPinia(vue) {
  vue.use(PiniaVuePlugin);
  return createPinia();
}

/**
 * Initializes stores.
 *
 * <p>Must be called after Pinia is set up: `new Vue({ pinia: createPinia() })`.
 */
export function initStores() {
  // Products details for filtering:
  //TODO:04.01.2023:yehor.pytomets: Uncomment when product filtering is ready.
  // useProductDropDownItemsStore().init();

  // Stores for wizard pages:
  useProductsStore().init();
}

/**
 * Resets stores to defaults.
 *
 * <p>Must be called after Pinia is set up: `new Vue({ pinia: createPinia() })`.
 */
export function resetStores() {
  useCommercialLicensesStore().reset();

  //TODO:04.01.2023:yehor.pytomets: Uncomment when product filtering is ready:
  // useProductDropDownItemsStore().reset();

  useProductsStore().reset();
}
